/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Benefit_Teams_PermissionsInputs */



/**
* | output |
* | --- |
* | "Per-team model and space permissions" |
*
* @param {Plan_Gate_Benefit_Teams_PermissionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_benefit_teams_permissions = /** @type {((inputs?: Plan_Gate_Benefit_Teams_PermissionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Benefit_Teams_PermissionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modell- und Space-Berechtigungen pro Team")
	return /** @type {LocalizedString} */ ("Per-team model and space permissions")
});